module.exports = __webpack_public_path__ + "static/media/quick-book-logo.5d77d392.png";